import { Table } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import PropTypes from 'prop-types';
import ExistingPolicies from './ExistingPolicies';
import IconButton from '../../util/IconButton';

function DevicePolicyList({ policies = [], onAdd, onEdit, onRemove }) {
  return (
    <div style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
      {/* Using two tables to create the illusion of a fixed header. */}

      {/* Just show the headers */}
      <div style={{ maxHeight: '4.1em', overflow: 'hidden' }}>
        <Table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Policy</th>
              <th>IP Notation</th>
              <th>Status</th>
              <th>
                <IconButton
                  name="Add device policy"
                  icon={<IoMdAdd />}
                  tooltip="Add"
                  title="Add device policy"
                  onClick={onAdd}
                  variant="outline-secondary"
                  style={{ float: 'right' }}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <ExistingPolicies
              policies={policies}
              onEdit={onEdit}
              onRemove={onRemove}
              useTestIds={false}
            />
          </tbody>
        </Table>
      </div>

      {/* Just show the body */}
      <div style={{ maxHeight: '35em', overflow: 'scroll' }}>
        <Table style={{ margin: 0 }}>
          <tbody data-testid="policyRows">
            <ExistingPolicies
              policies={policies}
              onEdit={onEdit}
              onRemove={onRemove}
            />
          </tbody>
        </Table>
      </div>
    </div>
  );
}

DevicePolicyList.propTypes = {
  policies: PropTypes.array,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
};

export default DevicePolicyList;
